import { Box, Button, CircularProgress, Grid, Typography } from "@mui/material";
import CustomTextFiled from "components/CustomTextField";
import { FORM_VALIDATIONS } from "constants/formValidation";
import { OTP_TYPE } from "constants/general";
import { Fragment, useEffect, useRef, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { sendOTP, setOtpVerification } from "slices/authReducers";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import VerifyMobileOtp from "./VerifyMobileOtp";

const ChangePhoneNumber = ({ showDialog, setShowDialog }: any) => {
  const { control, setValue, getValues } = useFormContext();
  const [otp, setOtp] = useState("");
  const { authReducer }: any = useAppSelector((state) => state);
  const { verifyingOtp }: any = authReducer;
  const [showOtpScreen, setShowOtpScreen] = useState(false);
  const [sendingOtp, setSendingOtp] = useState(false);
  const dispatch = useAppDispatch();
  const childRef: any = useRef(null);
  const verifyOtp = childRef?.current?.verifyOtp;

  const cancelHandler = () => {
    setShowDialog(false);
    setValue("new_mobile_number", "");
  };

  useEffect(() => {
    setValue("country_code", "+1");
  }, []);
  const updateHandler = () => {
    if (!showOtpScreen) {
      setSendingOtp(true);
      dispatch(setOtpVerification(true));
      dispatch(
        sendOTP({
          data: {
            mobile_number: getValues()?.new_mobile_number,
            country_code: getValues()?.country_code,
          },
          navigate: () => {
            setSendingOtp(false);
            return setShowOtpScreen(true);
          },
          onError: () => {
            setSendingOtp(false);
          },
        })
      );
    } else {
      verifyOtp(otp);
    }
  };
  return (
    <Box sx={{ p: 5 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontSize: "26px",
              fontWeight: "700",
              lineHeight: "31.47px",
              textAlign: "center",
            }}
          >
            {showOtpScreen ? "OTP Verification" : "Change Phone Number!"}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontSize: "16px",
              fontWeight: "500",
              lineHeight: "24px",
              textAlign: "center",
              color: "#A2A2A2",
            }}
          >
            {!showOtpScreen
              ? `Please provide your updated phone number for continued
            communication. Rest assured, your information will be kept
            confidential, ensuring seamless interaction.`
              : `Please enter the 6-digit OTP sent to your registered phone number ${
                  getValues().new_mobile_number
                }`}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          {showOtpScreen ? (
            <Fragment>
              <VerifyMobileOtp
                ref={childRef}
                otp={otp}
                setOtp={setOtp}
                onSuccess={() => {
                  setValue("mobile_number", getValues()?.new_mobile_number);
                  setValue("mobile_number_verified", 1);
                  cancelHandler();
                }}
                phone={getValues().new_mobile_number}
                otpType={OTP_TYPE.MOBILE}
              />
            </Fragment>
          ) : (
            <Controller
              control={control}
              name="new_mobile_number"
              defaultValue=""
              rules={{
                ...FORM_VALIDATIONS.REQUIRED_MOBILE,
                ...FORM_VALIDATIONS.maxLengthValidation(10),
                ...FORM_VALIDATIONS.minLengthValidation(10),
              }}
              render={({
                field: { value, onChange },
                fieldState: { error },
              }) => (
                <CustomTextFiled
                  inputValue={value}
                  label="mobile number"
                  onInputChange={onChange}
                  showError={!!error}
                  errorMessage={error?.message || " "}
                  dropDownOptions={[{ id: "+1", name: "+1" }]}
                  showEndDropDown={true}
                  dropDownValue="+1"
                  onDropDownChange={() => {}}
                  dropDownPosition="left"
                  showVerifiedIconAtEnd={false}
                />
              )}
            />
          )}
        </Grid>

        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <Button
            variant="outlined"
            size="large"
            fullWidth
            onClick={cancelHandler}
            disabled={sendingOtp || verifyingOtp}
            sx={{ borderColor: " #A2A2A2", color: "#A2A2A2" }}
          >
            Cancel
          </Button>
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
          <Button
            variant="contained"
            size="large"
            fullWidth
            onClick={updateHandler}
            disabled={
              sendingOtp ||
              verifyingOtp ||
              getValues()?.new_mobile_number?.length < 10
            }
            endIcon={
              sendingOtp || verifyingOtp ? <CircularProgress size={15} /> : null
            }
          >
            {showOtpScreen ? "Verify" : "Submit"}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ChangePhoneNumber;
